<template>
	<div>
		<b-modal id="modalSell" hide-header hide-footer dialog-class="modal-fullscreen" scrollable centered>
			<div class="modal-header">
				<div class="d-flex align-items-center pt-3 pb-3">
					<i @click="$bvModal.hide('modalSell')" class="icon icon-chevron-left mr-2"></i>
					<h3 class="modal-title">Registrar venta</h3>
				</div>
			</div>
			<div class="modal-container">
				<SellForm @created="$emit('created')" />
			</div>
		</b-modal>
	</div>
</template>

<script>
import SellForm from '@/views/SellForm'

export default {
	name: 'SellFormModal',
	components: {
		SellForm,
	},
	methods: {
		open() {
			this.$bvModal.show('modalSell')
		},
	},
}
</script>

<style scoped></style>
